import * as React from 'react';
import Button from '../../../../../common/components/Button';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import {TurboCashOfferStateProps, TurboCashOfferDispatchProps} from '../../../../types/mx/creditoReal/containers';

class TurboCashOfferView extends React.Component<TurboCashOfferStateProps & TurboCashOfferDispatchProps, {}> {

    constructor(props) {
        super(props);
    }

    render() {
        const {title, descriptionHtml, onAcceptOffer, onRefuseOffer, descriptionStyledHtml} = this.props;
        return <React.Fragment>
            <div className="row d-flex justify-content-center">
                <div className="container">
                    <div className="row mb-4 mt-3">
                        <div className="col text-center">
                            <img alt="gift" src={AssetsManager('/assets/images/common/thin-gift.svg')}/>
                        </div>
                    </div>
                    <div className="row mb-2 mt-3">
                        <div className="col text-center">
                            <p className="main-title">
                                {title}
                            </p>
                        </div>
                    </div>
                    <div className="row p-none mb-2">
                        <div className="col text-justify">
                            <div className="margin-offers" dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
                            <div dangerouslySetInnerHTML={{ __html: descriptionStyledHtml }} />
                        </div>
                    </div>
                    <div className="row pt-4 mt-4 border-top">
                        <div className="col mb-4 cursor-pointer">
                            <p onClick={() => onRefuseOffer()} role="button"
                               className="link-text-center mt-3 px-md-5 btn-block w-100" >
                                No acepto
                            </p>
                        </div>
                        <div className="col mb-4">
                            <Button text="Aceptar oferta"
                                    onPress={onAcceptOffer}
                                    role="button"
                                    customClass="right px-md-5 btn-block w-100"/>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>;

    }
}

export default TurboCashOfferView;